import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Histogram from "highcharts/modules/histogram-bellcurve";
import Boost from "highcharts/modules/boost";
import HighchartsExporting from "highcharts/modules/exporting";

HighchartsExporting(Highcharts);
Histogram(Highcharts);
Boost(Highcharts);

const chartOptions = (chartData, hoverDataHandler, clearHoverDataHandler, dataUnits) => {
  // console.log(" in options " + chartData)

  if (chartData.length <= 0) return null;

  // dont initialize with zero - for instance , if all chartData values are positive, then chartMin stays as zero
  // and chart always starts at x value of zero
  let chartMin = chartData[0]["y"];
  let chartMax = chartData[0]["y"];
  let uniqueValues = {};
  let countPerValue = {};

  // get min and max and also the unique values(using 'Set' does not work here)
  // for these large arrays , the 'for' loop has better performance
  for (let i = 0; i < chartData?.length; i++) {
    let val = chartData[i]["y"];
    chartMin = chartMin <= val ? chartMin : val;
    chartMax = chartMax >= val ? chartMax : val;
   
    if (!uniqueValues.hasOwnProperty(val)) {
      uniqueValues[val] = chartData[i]["color"];
      countPerValue[val] = 1
    } else {
      countPerValue[val] = countPerValue[val] + 1;
    }
  }

  // convert dict keys to numbers
  let uniqueKeys = Object.keys(uniqueValues).map((v) => Number(v));

  let xCategories = []
  let colColors = []
  let lowerCategoryVal = chartMin
  let countPerCategory = []
  
  if (uniqueKeys.length === 1) {
    //if all pixels diff is same (if map 1 and 2 are same)
    let uniqVal = uniqueKeys[0].toString()
    xCategories.push(uniqVal)
    colColors.push(uniqueValues[uniqVal])
    countPerCategory.push(countPerValue[uniqVal])
    
  } else {
    
    uniqueKeys.sort((a, b) => a - b);

    let colRange = Math.ceil(uniqueKeys.length / 10);
    for (let i = 1; i <= 10; i++) {
      let val = uniqueKeys[colRange * i] ? uniqueKeys[colRange * i] : chartMax;
      
      xCategories.push(lowerCategoryVal + " to " + val)
      colColors.push(uniqueValues[val.toString()])
      
      // get sum of count of each values that falls in this column
      // eslint-disable-next-line no-loop-func
      let currColValues = uniqueKeys.filter(uniqKy => (uniqKy >= lowerCategoryVal && uniqKy <= val))    
      let sum = 0
      for (const colVal of currColValues) {      
        sum += countPerValue[colVal]     
      }
      countPerCategory.push(sum)
      
      // set next lower val using next unique key ( so that same value is not counted twice) 
      lowerCategoryVal = uniqueKeys[(colRange * i) + 1] ? uniqueKeys[(colRange * i) + 1] : val; 
    }
  }
  
  let totalCount = chartData.length  
  let yValues = countPerCategory.map(cnt => Number((cnt/totalCount*100).toFixed(2))  ) 
  // console.log(yValues);
   
  return {
    
    title: {
      text: "",
    },

    chart: {
      spacingRight: 5,
      backgroundColor: "#2b2b2b",
      type:"column"
    },

    legend: {
      enabled: false,
      style: {
        color: "#fffff",
      },
      itemStyle: {
        color: "#ffffff",
      },
      itemHoverStyle: {
        color: "#f1f1f1",
      },
    },

    xAxis: [      
      {
        categories: xCategories,
        title: {
          text: "Difference - " + dataUnits,
          style: {
            color: "#ffffff",
          },
        },
        labels: {
          enabled: false
        },
        opposite: false,       
      },
    ],

    yAxis: [     
      {
        title: {
          text: "Percentage",
          style: {
            color: "#ffffff",
          },
        },
        labels: {
          style: {
            color: "#ffffff",
          },
        },
        opposite: false,
      },
    ],

    tooltip: {      
      formatter: function () {
        return "<span style='font-size: 12px'>Range: <b>" + this.x + "</b></span><br/>Percent: <b>" + this.y + " %</b>"
      }
    },
            
    plotOptions: {
      
      column: {
        pointPadding: 0,
        borderWidth: 0,
        groupPadding: 0,
        shadow: false,
        colors: colColors
      },
       
      series: {
        point: {
          events: {
            mouseOver: (evt) => {
              let val = evt.target.category
              let idx = val.indexOf(" to ")
              hoverDataHandler(Number(val.slice(0,idx)), Number(val.slice(idx+4)));
            },
            mouseOut: (evt) => {               
              clearHoverDataHandler();
            }
          }          
        }
      },
    },

    boost: {
      useGPUTranslations: true,
    },

    series: [{
      name: 'Data',
      data: yValues,
      colorByPoint: true,
      states: {
        hover: {
            color: 'rgb(0,255,255)'
        },
        normal: {
          animation: false
        }
      }
    }]        
  };
};

const emptyChart = () => {
  return {
    title: {
      text: "No data available",
    },
    series: [],
  };
};

const PixelHistogram = (props) => {
  // console.log(props)

  let options = chartOptions(
    props.chartData,
    props.hoverDataHandler,
    props.clearHoverDataHandler,
    props.dataUnits
  );

  if (!options) options = emptyChart();

  return (
    <HighchartsReact
      highcharts={Highcharts}
      containerProps={{ style: { height: "calc(100% - 16px)", width: "100%" } }}
      options={options}
      oneToOne={true}
    />
  );
};

export default PixelHistogram;
